import { Outlet } from "react-router-dom";

export default function Invoices() {
    return (
        <div className="rx-invoices">
            Invoices页面
        </div>
    );
}
